module.exports = __webpack_public_path__ + "b7eac402ce77f700ef51ceab77a81c8f.svg";